import React from 'react';
import { TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Search as SearchIcon } from '@mui/icons-material';

/**
 * @param {import('@mui/material').TextFieldProps} props
 */
export default function SearchField(props) {
    const {
        InputProps,
        ...other
    } = props;

    const classes = useStyles(InputProps);
    const iconClasses = useIconStyles();

    return (
        <TextField
            variant='filled'
            InputProps={{
                disableUnderline: true,
                ...InputProps,

                classes: classes,
                startAdornment: <SearchIcon classes={iconClasses} />,
            }}
            placeholder='Search...'
            {...other}
        />
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: 4,
    },
    input: {
        padding: theme.spacing(2),
        paddingLeft: 0
    },
    adornedStart: {
        paddingLeft: theme.spacing(2),
    },
}));

const useIconStyles = makeStyles(theme => ({
    root: {
        color: '#757575',
        marginRight: theme.spacing(2),
    }
}));